// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

let globalServiceInstance = null;

export class GlobalService {
  constructor() {
    this.lastUpdatedAt = Date.now();
  }

  static getGlobalServiceInstance() {
    if (!globalServiceInstance) {
      globalServiceInstance = new GlobalService();
    }
    return globalServiceInstance;
  }

  // Instance methods
  setLastUpdatedAt(timestamp) {
    this.lastUpdatedAt = timestamp;
  }

  getLastUpdatedAt() {
    return this.lastUpdatedAt;
  }
}
